import { encryptPDF } from "@pdfsmaller/pdf-encrypt";

export type PdfEncryptionOptions = {
  userPassword: string;
  ownerPassword?: string;
  allowPrinting?: boolean;
  allowModifying?: boolean;
  allowCopying?: boolean;
  allowAnnotating?: boolean;
};

export type PasswordStrength = "weak" | "fair" | "strong";
export function passwordStrength(password: string): PasswordStrength {
  const score = Number(password.length >= 8) + Number(/[a-z]/.test(password) && /[A-Z]/.test(password)) + Number(/\d/.test(password)) + Number(/[^A-Za-z0-9]/.test(password));
  return score >= 4 ? "strong" : score >= 2 ? "fair" : "weak";
}

export async function encryptPdfBuffer(buffer: ArrayBuffer, options: PdfEncryptionOptions): Promise<ArrayBuffer> {
  if (options.userPassword.length < 8) throw new Error("Use a password with at least 8 characters.");
  if (passwordStrength(options.userPassword) === "weak") throw new Error("Use a stronger password with mixed case, numbers, or symbols.");
  const encrypted = await encryptPDF(new Uint8Array(buffer), options.userPassword, {
    ownerPassword: options.ownerPassword || undefined,
    algorithm: "AES-256",
    allowPrinting: options.allowPrinting ?? true,
    allowModifying: options.allowModifying ?? false,
    allowCopying: options.allowCopying ?? false,
    allowAnnotating: options.allowAnnotating ?? true,
  });
  return encrypted.buffer.slice(encrypted.byteOffset, encrypted.byteOffset + encrypted.byteLength) as ArrayBuffer;
}
